import React, { useState } from 'react';
import { TitlePage } from '../../components/TitlePage/TitlePage';
import { DynamicFormComponent } from '../../components/DynamicFormComponent/DynamicFormComponent';
import account from './img/account.svg'
import { Tooltip } from '../../components/TooltipV2/Tooltip';
import { ButtonWithIcon } from '../../components/Buttons/ButtonWithIcon/ButtonWithIcon';
import SimpleFlowEditor from '../../components/ReactFlow/ReactFlow';
import './Test.scss'

const numberFormats = [
    { label: 'ru-RU (по-русски)', format: new Intl.NumberFormat('ru-RU') },
    { label: 'en-US (по-английски)', format: new Intl.NumberFormat('en-US') },
    { label: 'Currency: USD', format: new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }) },
    { label: 'Currency: RUB', format: new Intl.NumberFormat('ru-RU', { style: 'currency', currency: 'RUB' }) },
    { label: 'Percent', format: new Intl.NumberFormat('en-US', { style: 'percent', minimumFractionDigits: 2 }) },
    { label: 'No grouping', format: new Intl.NumberFormat('en-US', { useGrouping: false }) },
    { label: 'Min 4 fraction digits', format: new Intl.NumberFormat('en-US', { minimumFractionDigits: 4 }) },
];

const fontVariants = [
    'normal',
    'lining-nums',
    'oldstyle-nums',
    'proportional-nums',
    'tabular-nums',
    'slashed-zero',
    'stacked-fractions',
];

const number = 10000.5;

const initialAttributes = [
    {
        "id": "price",
        "attribute_name": "price",
        "description": "",
        "required": false,
        "is_dict_value": false,
        "is_array": false,
        "data_type": "float",
        "value": null,
        "front_name": "Цена"
    },
    {
        "id": "8229",
        "attribute_name": "Тип",
        "description": "Выберите из списка наиболее подходящий тип товара. Типы участвуют в распределении товаров по категориям на сайте Ozon. Чтобы правильно указать тип, найдите на сайте Ozon товары, похожие на ваш, и укажите в этом поле такой же тип.",
        "required": true,
        "is_dict_value": true,
        "is_array": false,
        "data_type": "str",
        "value": null
    },
    {
        "id": "3f8cbbbe-4a0a-4103-9a33-97bb8ba25c15",
        "attribute_name": "Активен",
        "description": "Да/НЕТ",
        "required": false,
        "is_dict_value": false,
        "is_array": false,
        "data_type": "bool",
        "value": null
    },
    {
        "id": "3f8cbbbe-4a0a-4103-9a33-97bb8ba25c15",
        "attribute_name": "Учтен",
        "description": "",
        "required": false,
        "is_dict_value": false,
        "is_array": false,
        "data_type": "bool",
        "value": null
    },
    {
        "id": "67c22da3-3dfa-4025-bbd0-c06a6bad9a71",
        "attribute_name": "Дробное число",
        "description": "",
        "required": false,
        "is_dict_value": false,
        "is_array": false,
        "data_type": "float",
        "value": null
    },
    {
        "id": "c186b1e7-0ada-4114-b382-80c4e473841f",
        "attribute_name": "Список",
        "description": "Введите список значений через Enter",
        "required": false,
        "is_dict_value": false,
        "is_array": true,
        "data_type": "str",
        "value": null
    },
    {
        "id": "3cc3be2c-a10f-44c0-85fc-bb6a9a4a4998",
        "attribute_name": "Строка",
        "description": "Введите текст",
        "required": false,
        "is_dict_value": false,
        "is_array": false,
        "data_type": "str",
        "value": null
    },
    {
        "id": "e2cd2281-6785-4242-ae4e-3a125d221dbc",
        "attribute_name": "целое число",
        "description": "",
        "required": false,
        "is_dict_value": false,
        "is_array": false,
        "data_type": "int",
        "value": null
    }
]

const articles = [
    {
        "Старый id статьи": 108,
        "Новый id статьи": 6616,
        "Старый url": "https://ecomru.ru/ru/article/reshenie_monitoringa_i_analitiki_konkurentov_v_ecommerce_na_marketplejsah_i_v_internet-magazinah_cherez_parsing/108",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/reshenie_monitoringa_i_analitiki_konkurentov_v_ecommerce_na_marketplejsah_i_v_internet-magazinah_cherez_parsing/6616",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 155,
        "Новый id статьи": 6617,
        "Старый url": "https://ecomru.ru/ru/article/oshibki_biznes-analitika_pri_rabote_na_marketplejse/155",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/oshibki_biznes-analitika_pri_rabote_na_marketplejse/6617",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 156,
        "Новый id статьи": 6618,
        "Старый url": "https://ecomru.ru/ru/article/vybor_nishi_i_analiz_konkurentov_na_vajldberriz/156",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/vybor_nishi_i_analiz_konkurentov_na_vajldberriz/6618",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 160,
        "Новый id статьи": 6619,
        "Старый url": "https://ecomru.ru/ru/article/reputatsija_pod_kontrolem_–_3_sposoba_uspeha/160",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/reputatsija_pod_kontrolem_–_3_sposoba_uspeha/6619",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 161,
        "Новый id статьи": 6620,
        "Старый url": "https://ecomru.ru/ru/article/digital-instrumenty_dlja_raboty_s_marketplejsami/161",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/digital-instrumenty_dlja_raboty_s_marketplejsami/6620",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 162,
        "Новый id статьи": 6621,
        "Старый url": "https://ecomru.ru/ru/article/broshennye_korziny_–_prichiny_oshibki_reshenija/162",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/broshennye_korziny_–_prichiny_oshibki_reshenija/6621",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 163,
        "Новый id статьи": 6622,
        "Старый url": "https://ecomru.ru/ru/article/chto-prodavat-na-novyi-god-na-marketpleisakh/163",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/chto-prodavat-na-novyi-god-na-marketpleisakh/6622",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 164,
        "Новый id статьи": 6623,
        "Старый url": "https://ecomru.ru/ru/article/epidemiia-poddelok-na-marketpleisakh-sovety-proizvoditeliam-i-potrebiteliam/164",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/epidemiia-poddelok-na-marketpleisakh-sovety-proizvoditeliam-i-potrebiteliam/6623",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 165,
        "Новый id статьи": 6624,
        "Старый url": "https://ecomru.ru/ru/article/razrabatyvaem_analiticheskie_onlajn_dashbordy_dlja_vashego_biznesa/165",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/razrabatyvaem_analiticheskie_onlajn_dashbordy_dlja_vashego_biznesa/6624",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 166,
        "Новый id статьи": 6625,
        "Старый url": "https://ecomru.ru/ru/article/avtomatiziruem_vashe_tsenoobrazovanie_v_e-commerce:_reshenie_dlja_internet_magazinov_marketplejsov_postavschikov/166",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/avtomatiziruem_vashe_tsenoobrazovanie_v_e-commerce:_reshenie_dlja_internet_magazinov_marketplejsov_postavschikov/6625",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 167,
        "Новый id статьи": 6626,
        "Старый url": "https://ecomru.ru/ru/article/razrabotka_i_vnedrenie_pim_sistem/167",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/razrabotka_i_vnedrenie_pim_sistem/6626",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 168,
        "Новый id статьи": 6627,
        "Старый url": "https://ecomru.ru/ru/article/kak_nachat_prodavat_na_jandeksmarket/168",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kak_nachat_prodavat_na_jandeksmarket/6627",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 169,
        "Новый id статьи": 6628,
        "Старый url": "https://ecomru.ru/ru/article/kak_nachat_prodavat_na_vajldberriz/169",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kak_nachat_prodavat_na_vajldberriz/6628",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 170,
        "Новый id статьи": 6629,
        "Старый url": "https://ecomru.ru/ru/article/kak_nachat_prodavat_na_ozon/170",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kak_nachat_prodavat_na_ozon/6629",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 171,
        "Новый id статьи": 6630,
        "Старый url": "https://ecomru.ru/ru/article/chto_takoe_megamarket/171",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/chto_takoe_megamarket/6630",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 172,
        "Новый id статьи": 6631,
        "Старый url": "https://ecomru.ru/ru/article/uslugi_parsinga_sajtov/172",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/uslugi_parsinga_sajtov/6631",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 173,
        "Новый id статьи": 6632,
        "Старый url": "https://ecomru.ru/ru/article/servis_avtomaticheskogo_perenosa_kartochek_tovarov_mezhdu_marketplejsami/173",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/servis_avtomaticheskogo_perenosa_kartochek_tovarov_mezhdu_marketplejsami/6632",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 175,
        "Новый id статьи": 6653,
        "Старый url": "https://ecomru.ru/ru/article/chto_nuzhno_chtoby_horosho_prodavat_na_marketplejsah/175",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/chto_nuzhno_chtoby_horosho_prodavat_na_marketplejsah/6653",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 176,
        "Новый id статьи": 6654,
        "Старый url": "https://ecomru.ru/ru/article/vygodno_li_torgovat_na_marketplejsah/176",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/vygodno_li_torgovat_na_marketplejsah/6654",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 177,
        "Новый id статьи": 6654,
        "Старый url": "https://ecomru.ru/ru/article/vygodno_li_torgovat_na_marketplejsah/177",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/vygodno_li_torgovat_na_marketplejsah/6654",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 178,
        "Новый id статьи": 6636,
        "Старый url": "https://ecomru.ru/ru/article/kak_vybrat_shemu_prodazhi_na_marketplejsah/178",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kak_vybrat_shemu_prodazhi_na_marketplejsah/6636",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 182,
        "Новый id статьи": 6637,
        "Старый url": "https://ecomru.ru/ru/article/pokazateli_ozona/182",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/pokazateli_ozona/6637",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 183,
        "Новый id статьи": 6638,
        "Старый url": "https://ecomru.ru/ru/article/ves_ili_ne_ves_assortiment_prodavat_na_marketplejsah/183",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/ves_ili_ne_ves_assortiment_prodavat_na_marketplejsah/6638",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 184,
        "Новый id статьи": 6639,
        "Старый url": "https://ecomru.ru/ru/article/kakaja_komanda_nuzhna_dlja_raboty_na_marketplejse/184",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kakaja_komanda_nuzhna_dlja_raboty_na_marketplejse/6639",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 185,
        "Новый id статьи": 6640,
        "Старый url": "https://ecomru.ru/ru/article/analitika_dlja_marketplejsov/185",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/analitika_dlja_marketplejsov/6640",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 186,
        "Новый id статьи": 6641,
        "Старый url": "https://ecomru.ru/ru/article/kakie_dokumenty_nuzhny_dlja_registratsii_na_marketplejsah/186",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kakie_dokumenty_nuzhny_dlja_registratsii_na_marketplejsah/6641",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 187,
        "Новый id статьи": 6642,
        "Старый url": "https://ecomru.ru/ru/article/ekspress-kejs\nparsing_i_monitoring_tsen_konkurentov_+_tsenoobrazovanie_dlja_krupnogo_prodavtsa_elektroniki_na_marketplejsah/187",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/ekspress-kejs\nparsing_i_monitoring_tsen_konkurentov_+_tsenoobrazovanie_dlja_krupnogo_prodavtsa_elektroniki_na_marketplejsah/6642",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 188,
        "Новый id статьи": 6643,
        "Старый url": "https://ecomru.ru/ru/article/ekspress-kejs\nparsing_i_monitoring_pozitsij_v_vydache_po_tovaram_prodavtsa_wildberries_dlja_otsenki_vlijanija_promo-aktivnostej/188",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/ekspress-kejs\nparsing_i_monitoring_pozitsij_v_vydache_po_tovaram_prodavtsa_wildberries_dlja_otsenki_vlijanija_promo-aktivnostej/6643",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 189,
        "Новый id статьи": 6644,
        "Старый url": "https://ecomru.ru/ru/article/ekspress-kejs_parsing_i_monitoring_konkurentov_po_tsenam_rejtingam_otzyvam_ostatkam_dlja_krupnogo_farmatsevticheskogo_brenda/189",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/ekspress-kejs_parsing_i_monitoring_konkurentov_po_tsenam_rejtingam_otzyvam_ostatkam_dlja_krupnogo_farmatsevticheskogo_brenda/6644",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 190,
        "Новый id статьи": 6645,
        "Старый url": "https://ecomru.ru/ru/article/kejs_farmproizvoditelja_\nkak_my_avtomatizirovali_monitoring_konkurentov_dlja_mezhdunarodnogo_farmatsevticheskogo_brenda/190",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kejs_farmproizvoditelja_\nkak_my_avtomatizirovali_monitoring_konkurentov_dlja_mezhdunarodnogo_farmatsevticheskogo_brenda/6645",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 191,
        "Новый id статьи": 6646,
        "Старый url": "https://ecomru.ru/ru/article/servis_avtomaticheskogo_podbora_kljuchevyh_slov/191",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/servis_avtomaticheskogo_podbora_kljuchevyh_slov/6646",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 267,
        "Новый id статьи": 6647,
        "Старый url": "https://ecomru.ru/ru/article/sbor_semanticheskogo_jadra_dlja_marketplejsa/267",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/sbor_semanticheskogo_jadra_dlja_marketplejsa/6647",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 280,
        "Новый id статьи": 6648,
        "Старый url": "https://ecomru.ru/ru/article/kak_prodavat_bady_na_marketplejsah/280",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kak_prodavat_bady_na_marketplejsah/6648",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 281,
        "Новый id статьи": 6649,
        "Старый url": "https://ecomru.ru/ru/article/marketplejs_detskij_mir:_obzor_ploschadki/281",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/marketplejs_detskij_mir:_obzor_ploschadki/6649",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 282,
        "Новый id статьи": 6650,
        "Старый url": "https://ecomru.ru/ru/article/marketplejs_amazon:_obzor_ploschadki/282",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/marketplejs_amazon:_obzor_ploschadki/6650",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 284,
        "Новый id статьи": 6627,
        "Старый url": "https://ecomru.ru/ru/article/kak_nachat_prodavat_na_jandeksmarket/284",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kak_nachat_prodavat_na_jandeksmarket/6627",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 286,
        "Новый id статьи": 6652,
        "Старый url": "https://ecomru.ru/ru/article/rabota_s_ozon_po_fbs:_adresa_punktov_priema/286",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/rabota_s_ozon_po_fbs:_adresa_punktov_priema/6652",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 287,
        "Новый id статьи": 6653,
        "Старый url": "https://ecomru.ru/ru/article/chto_nuzhno_chtoby_horosho_prodavat_na_marketplejsah/287",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/chto_nuzhno_chtoby_horosho_prodavat_na_marketplejsah/6653",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 288,
        "Новый id статьи": 6654,
        "Старый url": "https://ecomru.ru/ru/article/vygodno_li_torgovat_na_marketplejsah/288",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/vygodno_li_torgovat_na_marketplejsah/6654",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 289,
        "Новый id статьи": 6656,
        "Старый url": "https://ecomru.ru/ru/article/kak_monitorjat_tseny_markeplejsy/289",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kak_monitorjat_tseny_markeplejsy/6656",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 290,
        "Новый id статьи": 6656,
        "Старый url": "https://ecomru.ru/ru/article/kak_monitorjat_tseny_markeplejsy/290",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kak_monitorjat_tseny_markeplejsy/6656",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 292,
        "Новый id статьи": 6657,
        "Старый url": "https://ecomru.ru/ru/article/aliexpress:_obzor_ploschadki/292",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/aliexpress:_obzor_ploschadki/6657",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 293,
        "Новый id статьи": 6658,
        "Старый url": "https://ecomru.ru/ru/article/marketplejs_mvideo:_obzor_ploschadki/293",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/marketplejs_mvideo:_obzor_ploschadki/6658",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 294,
        "Новый id статьи": 6659,
        "Старый url": "https://ecomru.ru/ru/article/marketplejs_wildberries:_obzor_ploschadki/294",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/marketplejs_wildberries:_obzor_ploschadki/6659",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 296,
        "Новый id статьи": 6660,
        "Старый url": "https://ecomru.ru/ru/article/marketplejs_jandeks_market:_obzor_ploschadki/296",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/marketplejs_jandeks_market:_obzor_ploschadki/6660",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 298,
        "Новый id статьи": 6661,
        "Старый url": "https://ecomru.ru/ru/article/sbermegamarket:_obzor_ploschadki\n/298",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/sbermegamarket:_obzor_ploschadki\n/6661",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 299,
        "Новый id статьи": 6662,
        "Старый url": "https://ecomru.ru/ru/article/ozon:_obzor_ploschadki/299",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/ozon:_obzor_ploschadki/6662",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 301,
        "Новый id статьи": 6663,
        "Старый url": "https://ecomru.ru/ru/article/fulfilment_i_logistika_dlja_marketplejsov/301",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/fulfilment_i_logistika_dlja_marketplejsov/6663",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 302,
        "Новый id статьи": 6664,
        "Старый url": "https://ecomru.ru/ru/article/kak_stat_menedzherom_marketplejsov/302",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kak_stat_menedzherom_marketplejsov/6664",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 303,
        "Новый id статьи": 6665,
        "Старый url": "https://ecomru.ru/ru/article/analitika_na_ozon/303",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/analitika_na_ozon/6665",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 304,
        "Новый id статьи": 6666,
        "Старый url": "https://ecomru.ru/ru/article/analitika_na_wildberries/304",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/analitika_na_wildberries/6666",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 306,
        "Новый id статьи": 6667,
        "Старый url": "https://ecomru.ru/ru/article/kartochki_na_ozon/306",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kartochki_na_ozon/6667",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 307,
        "Новый id статьи": 6668,
        "Старый url": "https://ecomru.ru/ru/article/kak_prodavat_i_zarabatyvat_na_marketplejsah/307",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kak_prodavat_i_zarabatyvat_na_marketplejsah/6668",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 308,
        "Новый id статьи": 6669,
        "Старый url": "https://ecomru.ru/ru/article/kak_zavodit_kartochki_na_jandeks_markete/308",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kak_zavodit_kartochki_na_jandeks_markete/6669",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 309,
        "Новый id статьи": 6670,
        "Старый url": "https://ecomru.ru/ru/article/kak_zavodit_kartochki_tovarov_na_vajldberriz/309",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kak_zavodit_kartochki_tovarov_na_vajldberriz/6670",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 310,
        "Новый id статьи": 6671,
        "Старый url": "https://ecomru.ru/ru/article/kak_zavodit_kartochki_na_sbermega_market/310",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kak_zavodit_kartochki_na_sbermega_market/6671",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 311,
        "Новый id статьи": 6672,
        "Старый url": "https://ecomru.ru/ru/article/pravilnoe_sozdanie_idealnoj_kartochki_i_kak_uluchshit_prodazhi/311",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/pravilnoe_sozdanie_idealnoj_kartochki_i_kak_uluchshit_prodazhi/6672",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 324,
        "Новый id статьи": 6673,
        "Старый url": "https://ecomru.ru/ru/article/kak_nachat_prodavat_na_marketplejsah_s_nulja/324",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kak_nachat_prodavat_na_marketplejsah_s_nulja/6673",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 325,
        "Новый id статьи": 6674,
        "Старый url": "https://ecomru.ru/ru/article/5_oshibok_proizvoditelej_na_marketplejsah\n/325",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/5_oshibok_proizvoditelej_na_marketplejsah\n/6674",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 326,
        "Новый id статьи": 6675,
        "Старый url": "https://ecomru.ru/ru/article/vlijanie_logistiki_na_udovletvorennosti_pokupatelej/326",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/vlijanie_logistiki_na_udovletvorennosti_pokupatelej/6675",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 327,
        "Новый id статьи": 6676,
        "Старый url": "https://ecomru.ru/ru/article/vybor_tovarov_dlja_prodazh_–_bazovye_etapy/327",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/vybor_tovarov_dlja_prodazh_–_bazovye_etapy/6676",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 328,
        "Новый id статьи": 6677,
        "Старый url": "https://ecomru.ru/ru/article/vnedrenie_storitellinga_v_ritejl/328",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/vnedrenie_storitellinga_v_ritejl/6677",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 329,
        "Новый id статьи": 6678,
        "Старый url": "https://ecomru.ru/ru/article/top-besplatnyh_analitik-servisov_dlja_marketplejsov/329",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/top-besplatnyh_analitik-servisov_dlja_marketplejsov/6678",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 330,
        "Новый id статьи": 6679,
        "Старый url": "https://ecomru.ru/ru/article/novyj_servis_ecomseller_–_bystryj_perenos_kartochek_tovarov_s_ozona_na_jandeksmarket/330",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/novyj_servis_ecomseller_–_bystryj_perenos_kartochek_tovarov_s_ozona_na_jandeksmarket/6679",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 331,
        "Новый id статьи": 6680,
        "Старый url": "https://ecomru.ru/ru/article/tsepljajuschaja_kartochka_tovara:_sovety_po_sostavleniju/331",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/tsepljajuschaja_kartochka_tovara:_sovety_po_sostavleniju/6680",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 332,
        "Новый id статьи": 6681,
        "Старый url": "https://ecomru.ru/ru/article/fotografii_tovarov:_glavnye_printsipy_i_sekrety/332",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/fotografii_tovarov:_glavnye_printsipy_i_sekrety/6681",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 333,
        "Новый id статьи": 6682,
        "Старый url": "https://ecomru.ru/ru/article/tovary_dlja_marketplejsa:_luchshie_i_hudshie_varianty/333",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/tovary_dlja_marketplejsa:_luchshie_i_hudshie_varianty/6682",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 334,
        "Новый id статьи": 6683,
        "Старый url": "https://ecomru.ru/ru/article/wb_guru_–_novyj_servis_ot_wildberries/334",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/wb_guru_–_novyj_servis_ot_wildberries/6683",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 335,
        "Новый id статьи": 6684,
        "Старый url": "https://ecomru.ru/ru/article/kejs:_perenos_50_kartochek_tovarov_iz_magazina_na_ozon_v_magazin_na_jandeksmarket/335",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kejs:_perenos_50_kartochek_tovarov_iz_magazina_na_ozon_v_magazin_na_jandeksmarket/6684",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 336,
        "Новый id статьи": 6685,
        "Старый url": "https://ecomru.ru/ru/article/aktualnye_tovary_dlja_internet-magazina_v_2023_godu/336",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/aktualnye_tovary_dlja_internet-magazina_v_2023_godu/6685",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 337,
        "Новый id статьи": 6686,
        "Старый url": "https://ecomru.ru/ru/article/iz_instagram_v_marketplejs:_kak_perenesti_svoj_internet-magazin/337",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/iz_instagram_v_marketplejs:_kak_perenesti_svoj_internet-magazin/6686",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 338,
        "Новый id статьи": 6687,
        "Старый url": "https://ecomru.ru/ru/article/kak_izbezhat_oshibok_v_zapolnenii_opisanij_tovarov/338",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kak_izbezhat_oshibok_v_zapolnenii_opisanij_tovarov/6687",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 339,
        "Новый id статьи": 6688,
        "Старый url": "https://ecomru.ru/ru/article/kak_pisat_prodajuschee_opisanie_tovarov_v_marketplejsah/339",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kak_pisat_prodajuschee_opisanie_tovarov_v_marketplejsah/6688",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 340,
        "Новый id статьи": 6689,
        "Старый url": "https://ecomru.ru/ru/article/kakie_marketplejsy_razreshili_prodavat_«sanktsionnye»_tovary/340",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kakie_marketplejsy_razreshili_prodavat_«sanktsionnye»_tovary/6689",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 341,
        "Новый id статьи": 6690,
        "Старый url": "https://ecomru.ru/ru/article/komissii_marketplejsov/341",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/komissii_marketplejsov/6690",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 342,
        "Новый id статьи": 6691,
        "Старый url": "https://ecomru.ru/ru/article/osnovnye_tipy_marketplejsov/342",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/osnovnye_tipy_marketplejsov/6691",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 343,
        "Новый id статьи": 6692,
        "Старый url": "https://ecomru.ru/ru/article/problemy_nachinajuschih_prodavtsov_v_marketplejse/343",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/problemy_nachinajuschih_prodavtsov_v_marketplejse/6692",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 344,
        "Новый id статьи": 6693,
        "Старый url": "https://ecomru.ru/ru/article/rabota_s_tsenami_na_tovary_v_marketplejsah/344",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/rabota_s_tsenami_na_tovary_v_marketplejsah/6693",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 345,
        "Новый id статьи": 6694,
        "Старый url": "https://ecomru.ru/ru/article/ecomseller_voshel_v_top-20_krupnejshih_tehnologicheskih_partnerov_jandeksmarket/345",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/ecomseller_voshel_v_top-20_krupnejshih_tehnologicheskih_partnerov_jandeksmarket/6694",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 346,
        "Новый id статьи": 6695,
        "Старый url": "https://ecomru.ru/ru/article/samye_vazhnye_metriki_marketplejsov/346",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/samye_vazhnye_metriki_marketplejsov/6695",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 347,
        "Новый id статьи": 6696,
        "Старый url": "https://ecomru.ru/ru/article/trebovanija_k_upakovke_i_markirovke_tovara_v_raznyh_marketplejsah/347",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/trebovanija_k_upakovke_i_markirovke_tovara_v_raznyh_marketplejsah/6696",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 348,
        "Новый id статьи": 6697,
        "Старый url": "https://ecomru.ru/ru/article/trebovanija_k_oformleniju_kartochek_tovarov_v_raznyh_marketplejsah/348",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/trebovanija_k_oformleniju_kartochek_tovarov_v_raznyh_marketplejsah/6697",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 349,
        "Новый id статьи": 6698,
        "Старый url": "https://ecomru.ru/ru/article/kejs_po_perenosu_5000_sku_odezhdy_s_ozon_na_jandeksmarket/349",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kejs_po_perenosu_5000_sku_odezhdy_s_ozon_na_jandeksmarket/6698",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 350,
        "Новый id статьи": 6699,
        "Старый url": "https://ecomru.ru/ru/article/kak_prodavat_na_sbermegamarket/350",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kak_prodavat_na_sbermegamarket/6699",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 351,
        "Новый id статьи": 6711,
        "Старый url": "https://ecomru.ru/ru/article/kak_prodavat_na_wildberries_samozanjatym/351",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kak_prodavat_na_wildberries_samozanjatym/6711",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 352,
        "Новый id статьи": 6701,
        "Старый url": "https://ecomru.ru/ru/article/marketplejsy_2022:_rejting_otechestvennyh_i_zarubezhnyh_marketplejsov/352",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/marketplejsy_2022:_rejting_otechestvennyh_i_zarubezhnyh_marketplejsov/6701",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 353,
        "Новый id статьи": 6702,
        "Старый url": "https://ecomru.ru/ru/article/logistika_i_fulfilment_na_marketplejsah/353",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/logistika_i_fulfilment_na_marketplejsah/6702",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 354,
        "Новый id статьи": 6703,
        "Старый url": "https://ecomru.ru/ru/article/lajfhaki_dlja_oformlenija_tovarov_na_marketplejsah/354",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/lajfhaki_dlja_oformlenija_tovarov_na_marketplejsah/6703",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 355,
        "Новый id статьи": 6704,
        "Старый url": "https://ecomru.ru/ru/article/reklama_na_ozon:_kak_rabotaet_kak_nastroit_i_zapustit/355",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/reklama_na_ozon:_kak_rabotaet_kak_nastroit_i_zapustit/6704",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 356,
        "Новый id статьи": 6705,
        "Старый url": "https://ecomru.ru/ru/article/kak_vybrat_postavschika_dlja_markeplejsov:_top_luchshih_sovetov/356",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kak_vybrat_postavschika_dlja_markeplejsov:_top_luchshih_sovetov/6705",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 357,
        "Новый id статьи": 6706,
        "Старый url": "https://ecomru.ru/ru/article/marketplejsy_ozon_wildberries_i_lamoda_dogovorilis_ob_obschem_samoregulirovanii/357",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/marketplejsy_ozon_wildberries_i_lamoda_dogovorilis_ob_obschem_samoregulirovanii/6706",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 358,
        "Новый id статьи": 6707,
        "Старый url": "https://ecomru.ru/ru/article/kak_strimy_ozon_live_pomogajut_prodavat\n/358",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kak_strimy_ozon_live_pomogajut_prodavat\n/6707",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 359,
        "Новый id статьи": 6708,
        "Старый url": "https://ecomru.ru/ru/article/kak_zaregistrirovat_svoj_tovarnyj_znak_na_ozon/359",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kak_zaregistrirovat_svoj_tovarnyj_znak_na_ozon/6708",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 361,
        "Новый id статьи": 6711,
        "Старый url": "https://ecomru.ru/ru/article/kak_prodavat_na_wildberries_samozanjatym/361",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kak_prodavat_na_wildberries_samozanjatym/6711",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 363,
        "Новый id статьи": 6648,
        "Старый url": "https://ecomru.ru/ru/article/kak_prodavat_bady_na_marketplejsah/363",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kak_prodavat_bady_na_marketplejsah/6648",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 372,
        "Новый id статьи": 6711,
        "Старый url": "https://ecomru.ru/ru/article/kak_prodavat_na_wildberries_samozanjatym/372",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kak_prodavat_na_wildberries_samozanjatym/6711",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 373,
        "Новый id статьи": 6712,
        "Старый url": "https://ecomru.ru/ru/article/trebovanija_k_upakovke_tovarov_na_ozon/373",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/trebovanija_k_upakovke_tovarov_na_ozon/6712",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 374,
        "Новый id статьи": 6713,
        "Старый url": "https://ecomru.ru/ru/article/kak_prodavat_na_aliexpress_iz_rossii/374",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kak_prodavat_na_aliexpress_iz_rossii/6713",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 375,
        "Новый id статьи": 6714,
        "Старый url": "https://ecomru.ru/ru/article/v_chem_raznitsa_mezhdu_torgovoj_markoj_brendom_i_tovarnym_znakom/375",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/v_chem_raznitsa_mezhdu_torgovoj_markoj_brendom_i_tovarnym_znakom/6714",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 376,
        "Новый id статьи": 6715,
        "Старый url": "https://ecomru.ru/ru/article/kak_prodavat_na_ozon_so_svoego_sklada\n/376",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kak_prodavat_na_ozon_so_svoego_sklada\n/6715",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 377,
        "Новый id статьи": 6716,
        "Старый url": "https://ecomru.ru/ru/article/avtomatizatsija_ostatkov_tovara_na_marketplejsah/377",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/avtomatizatsija_ostatkov_tovara_na_marketplejsah/6716",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 378,
        "Новый id статьи": 6717,
        "Старый url": "https://ecomru.ru/ru/article/kak_otslezhivat_prodazhi_na_ozon\n/378",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kak_otslezhivat_prodazhi_na_ozon\n/6717",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 379,
        "Новый id статьи": 6718,
        "Старый url": "https://ecomru.ru/ru/article/kak_analitika_pomogaet_uvelichit_prodazhi_na_wb/379",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kak_analitika_pomogaet_uvelichit_prodazhi_na_wb/6718",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 380,
        "Новый id статьи": 6830,
        "Старый url": "https://ecomru.ru/ru/article/kejs:_podkljuchenie_seti_oflajn-magazinov_na_ozon_po_express_dostavke_naprjamuju_iz_magazina/380",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kejs:_podkljuchenie_seti_oflajn-magazinov_na_ozon_po_express_dostavke_naprjamuju_iz_magazina/6830",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 381,
        "Новый id статьи": 6720,
        "Старый url": "https://ecomru.ru/ru/article/avtomatizatsija_marketplejsov/381",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/avtomatizatsija_marketplejsov/6720",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 382,
        "Новый id статьи": 6721,
        "Старый url": "https://ecomru.ru/ru/article/kak_podobrat_nishu_s_uchetom_marzhi_konkurentsii_i_trendov/382",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kak_podobrat_nishu_s_uchetom_marzhi_konkurentsii_i_trendov/6721",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 383,
        "Новый id статьи": 6722,
        "Старый url": "https://ecomru.ru/ru/article/top_tovarov_osen-zima_2022:_chto_prodavat/383",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/top_tovarov_osen-zima_2022:_chto_prodavat/6722",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 384,
        "Новый id статьи": 6723,
        "Старый url": "https://ecomru.ru/ru/article/analiz_sobstvennyh_prodazh_na_marketplejse/384",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/analiz_sobstvennyh_prodazh_na_marketplejse/6723",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 385,
        "Новый id статьи": 6724,
        "Старый url": "https://ecomru.ru/ru/article/integratsija_lichnogo_kabineta_marketplejsa_po_api/385",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/integratsija_lichnogo_kabineta_marketplejsa_po_api/6724",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 386,
        "Новый id статьи": 6725,
        "Старый url": "https://ecomru.ru/ru/article/chem_polezno_soprovozhdenie_biznesa_na_marketplejsah/386",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/chem_polezno_soprovozhdenie_biznesa_na_marketplejsah/6725",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 387,
        "Новый id статьи": 6726,
        "Старый url": "https://ecomru.ru/ru/article/kak_prodvigat_tovary_na_wb_i_ozon/387",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kak_prodvigat_tovary_na_wb_i_ozon/6726",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 388,
        "Новый id статьи": 6727,
        "Старый url": "https://ecomru.ru/ru/article/vneshnjaja_reklama_dlja_kartochek_tovara_wb/388",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/vneshnjaja_reklama_dlja_kartochek_tovara_wb/6727",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 389,
        "Новый id статьи": 6728,
        "Старый url": "https://ecomru.ru/ru/article/seo-instrumenty_dlja_marketplejsov/389",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/seo-instrumenty_dlja_marketplejsov/6728",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 390,
        "Новый id статьи": 6729,
        "Старый url": "https://ecomru.ru/ru/article/analiz_konkurentov_na_marketplejsah/390",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/analiz_konkurentov_na_marketplejsah/6729",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 391,
        "Новый id статьи": 6730,
        "Старый url": "https://ecomru.ru/ru/article/trendy_i_sezonnost_na_marketplejsah/391",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/trendy_i_sezonnost_na_marketplejsah/6730",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 394,
        "Новый id статьи": 6731,
        "Старый url": "https://ecomru.ru/ru/article/personalnyj_menedzher_marketplejsov/394",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/personalnyj_menedzher_marketplejsov/6731",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 395,
        "Новый id статьи": 6732,
        "Старый url": "https://ecomru.ru/ru/article/o_kompanii/395",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/o_kompanii/6732",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 396,
        "Новый id статьи": 6733,
        "Старый url": "https://ecomru.ru/ru/article/besplatno_podkljuchim_k_jandeksmarket/396",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/besplatno_podkljuchim_k_jandeksmarket/6733",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 397,
        "Новый id статьи": 6734,
        "Старый url": "https://ecomru.ru/ru/article/politika_konfidentsialnosti/397",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/politika_konfidentsialnosti/6734",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 398,
        "Новый id статьи": 6735,
        "Старый url": "https://ecomru.ru/ru/article/besplatno_pomogaem_nachat_biznes_na_jandeksmarkete_i_megamarkete/398",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/besplatno_pomogaem_nachat_biznes_na_jandeksmarkete_i_megamarkete/6735",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 400,
        "Новый id статьи": 6736,
        "Старый url": "https://ecomru.ru/ru/article/marketplejsy_pod_kljuch/400",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/marketplejsy_pod_kljuch/6736",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 401,
        "Новый id статьи": 6737,
        "Старый url": "https://ecomru.ru/ru/article/servisy_avtomaticheskogo_uluchshenija_kartochek_tovarov/401",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/servisy_avtomaticheskogo_uluchshenija_kartochek_tovarov/6737",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 402,
        "Новый id статьи": 6738,
        "Старый url": "https://ecomru.ru/ru/article/avtomatiziruem_rabotu_na_marketplejsah/402",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/avtomatiziruem_rabotu_na_marketplejsah/6738",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 403,
        "Новый id статьи": 6739,
        "Старый url": "https://ecomru.ru/ru/article/avtomatiziruem_upravlenie_ostatkami_na_marketplejsah/403",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/avtomatiziruem_upravlenie_ostatkami_na_marketplejsah/6739",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 404,
        "Новый id статьи": 6740,
        "Старый url": "https://ecomru.ru/ru/article/kompleks_rabot_s_kontentom_na_marketplejsah/404",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kompleks_rabot_s_kontentom_na_marketplejsah/6740",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 405,
        "Новый id статьи": 6741,
        "Старый url": "https://ecomru.ru/ru/article/uslugi_kompleksnogo_prodvizhenija_i_analitiki_na_marketplejsah/405",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/uslugi_kompleksnogo_prodvizhenija_i_analitiki_na_marketplejsah/6741",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 432,
        "Новый id статьи": 6742,
        "Старый url": "https://ecomru.ru/ru/article/chto_takoe_parsing_informatsii_dlja_chego_nuzhen_biznesu_gde_i_kak_on_ispolzuetsja_obo_vsem_etom_my_rasskazhem_v_nashej_state/432",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/chto_takoe_parsing_informatsii_dlja_chego_nuzhen_biznesu_gde_i_kak_on_ispolzuetsja_obo_vsem_etom_my_rasskazhem_v_nashej_state/6742",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 434,
        "Новый id статьи": 6743,
        "Старый url": "https://ecomru.ru/ru/article/chto_takoe_pim-sistema_i_zachem_ona_nuzhna_biznesu_/434",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/chto_takoe_pim-sistema_i_zachem_ona_nuzhna_biznesu_/6743",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 436,
        "Новый id статьи": 6744,
        "Старый url": "https://ecomru.ru/ru/article/zachem_nuzhno_ispolzovat_pim-sistemu_pochemu_eto_vygodno_/436",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/zachem_nuzhno_ispolzovat_pim-sistemu_pochemu_eto_vygodno_/6744",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 437,
        "Новый id статьи": 6745,
        "Старый url": "https://ecomru.ru/ru/article/v_chem_raznitsa_mezhdu_pim_i_mdm_sistemami_chto_luchshe_podojdet_dlja_upravlenija_biznesom_/437",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/v_chem_raznitsa_mezhdu_pim_i_mdm_sistemami_chto_luchshe_podojdet_dlja_upravlenija_biznesom_/6745",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 438,
        "Новый id статьи": 6746,
        "Старый url": "https://ecomru.ru/ru/article/kejs_perfectmarket:_kak_pri_pomoschi_parsinga_my_avtomatizirovali_tsenoobrazovanie_krupnogo_magazina_kosmetiki_na_jandeksmarket/438",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kejs_perfectmarket:_kak_pri_pomoschi_parsinga_my_avtomatizirovali_tsenoobrazovanie_krupnogo_magazina_kosmetiki_na_jandeksmarket/6746",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 447,
        "Новый id статьи": 6747,
        "Старый url": "https://ecomru.ru/ru/article/pochemu_vazhno_avtomatizirovat_torgovlju_vnutri_marketplejsov/447",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/pochemu_vazhno_avtomatizirovat_torgovlju_vnutri_marketplejsov/6747",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 584,
        "Новый id статьи": 6748,
        "Старый url": "https://ecomru.ru/ru/article/kak_pri_pomoschi_parsinga_my_optimizirovali_vnutrennie_protsessy_odnogo_iz_samyh_populjarnyh_mezhdunarodnyh_brendov_fmcg/584",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kak_pri_pomoschi_parsinga_my_optimizirovali_vnutrennie_protsessy_odnogo_iz_samyh_populjarnyh_mezhdunarodnyh_brendov_fmcg/6748",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 585,
        "Новый id статьи": 6749,
        "Старый url": "https://ecomru.ru/ru/article/kak_pravilno_vnedrit_pim-sistemu/585",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kak_pravilno_vnedrit_pim-sistemu/6749",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 594,
        "Новый id статьи": 6750,
        "Старый url": "https://ecomru.ru/ru/article/kejs_parsinga_kak_za_1_nedelju_my_nastroili_effektivnyj_sbor_dannyh_dlja_krupnogo_marketplejsa_iz_sng/594",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kejs_parsinga_kak_za_1_nedelju_my_nastroili_effektivnyj_sbor_dannyh_dlja_krupnogo_marketplejsa_iz_sng/6750",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 595,
        "Новый id статьи": 6751,
        "Старый url": "https://ecomru.ru/ru/article/kejs_parsinga_kak_my_avtomatizirovali_parsing_konkurentov_analitiku_i_dashbordy_dlja_seti_restoranov_bystrogo_pitanija/595",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kejs_parsinga_kak_my_avtomatizirovali_parsing_konkurentov_analitiku_i_dashbordy_dlja_seti_restoranov_bystrogo_pitanija/6751",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 971,
        "Новый id статьи": 6752,
        "Старый url": "https://ecomru.ru/ru/article/kak_parsing_dannyh_pomogaet_v_analitike_otzyvov/971",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kak_parsing_dannyh_pomogaet_v_analitike_otzyvov/6752",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 972,
        "Новый id статьи": 6753,
        "Старый url": "https://ecomru.ru/ru/article/5_luchshih_reshenij_dlja_prohozhdenija_captcha_v_2024_godu/972",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/5_luchshih_reshenij_dlja_prohozhdenija_captcha_v_2024_godu/6753",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 973,
        "Новый id статьи": 6754,
        "Старый url": "https://ecomru.ru/ru/article/7_osnovnyh_njuansov_kotorye_stoit_uchityvat_pri_parsinge/973",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/7_osnovnyh_njuansov_kotorye_stoit_uchityvat_pri_parsinge/6754",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 974,
        "Новый id статьи": 6755,
        "Старый url": "https://ecomru.ru/ru/article/vse_chto_nuzhno_znat_o_parsinge_mobilnyh_prilozhenij_v_2024_godu/974",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/vse_chto_nuzhno_znat_o_parsinge_mobilnyh_prilozhenij_v_2024_godu/6755",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 975,
        "Новый id статьи": 6756,
        "Старый url": "https://ecomru.ru/ru/article/top-5_samyh_legkih_i_samyh_slozhnyh_sajtov_runeta_dlja_parsinga_dannyh/975",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/top-5_samyh_legkih_i_samyh_slozhnyh_sajtov_runeta_dlja_parsinga_dannyh/6756",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 976,
        "Новый id статьи": 6757,
        "Старый url": "https://ecomru.ru/ru/article/ot_kakih_faktorov_zavisit_pozitsija_kartochki_tovara_v_poiskovoj_vydache_na_marketplejse\n/976",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/ot_kakih_faktorov_zavisit_pozitsija_kartochki_tovara_v_poiskovoj_vydache_na_marketplejse\n/6757",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 977,
        "Новый id статьи": 6758,
        "Старый url": "https://ecomru.ru/ru/article/kakoe_vlijanie_na_prodazhi_okazyvaet_tsvet_izobrazhenij_v_kartochke_tovara/977",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kakoe_vlijanie_na_prodazhi_okazyvaet_tsvet_izobrazhenij_v_kartochke_tovara/6758",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 978,
        "Новый id статьи": 6759,
        "Старый url": "https://ecomru.ru/ru/article/kakovy_komissionnye_stavki_na_trendyol_v_2024_godu/978",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kakovy_komissionnye_stavki_na_trendyol_v_2024_godu/6759",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 979,
        "Новый id статьи": 6760,
        "Старый url": "https://ecomru.ru/ru/article/kak_uvelichit_dohod_brenda_na_marketplejsah_top-5_rabochih_metodov/979",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kak_uvelichit_dohod_brenda_na_marketplejsah_top-5_rabochih_metodov/6760",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 980,
        "Новый id статьи": 6761,
        "Старый url": "https://ecomru.ru/ru/article/kak_vo_vremja_otpuska_upravljat_svoim_magazinom_na_wildberries_ili_ozon/980",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kak_vo_vremja_otpuska_upravljat_svoim_magazinom_na_wildberries_ili_ozon/6761",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 981,
        "Новый id статьи": 6762,
        "Старый url": "https://ecomru.ru/ru/article/out-of-stock_strashnyj_son_ljubogo_sellera_kak_izbezhat_nulevogo_ostatka_na_marketplejse/981",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/out-of-stock_strashnyj_son_ljubogo_sellera_kak_izbezhat_nulevogo_ostatka_na_marketplejse/6762",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 982,
        "Новый id статьи": 6763,
        "Старый url": "https://ecomru.ru/ru/article/chto_takoe_junit-ekonomika_i_chem_ona_pomozhet_pri_torgovle_na_marketplejsah/982",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/chto_takoe_junit-ekonomika_i_chem_ona_pomozhet_pri_torgovle_na_marketplejsah/6763",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 983,
        "Новый id статьи": 6764,
        "Старый url": "https://ecomru.ru/ru/article/kak_rabotaet_voronka_prodazh_na_marketplejsah/983",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kak_rabotaet_voronka_prodazh_na_marketplejsah/6764",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 984,
        "Новый id статьи": 6765,
        "Старый url": "https://ecomru.ru/ru/article/chto_takoe_analiz_magazina_na_marketplejsah\n/984",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/chto_takoe_analiz_magazina_na_marketplejsah\n/6765",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 985,
        "Новый id статьи": 6766,
        "Старый url": "https://ecomru.ru/ru/article/osnovnye_printsipy_tsenoobrazovanija_na_marketplejsah_kak_rasschitat_tsenu_chtoby_tovar_prinosil_vysokuju_pribyl/985",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/osnovnye_printsipy_tsenoobrazovanija_na_marketplejsah_kak_rasschitat_tsenu_chtoby_tovar_prinosil_vysokuju_pribyl/6766",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 987,
        "Новый id статьи": 6767,
        "Старый url": "https://ecomru.ru/ru/article/kak_parsing_dannyh_pomogaet_sledit_za_konkurentami_v_onlajn-biznese_v_2024_godu\n/987",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kak_parsing_dannyh_pomogaet_sledit_za_konkurentami_v_onlajn-biznese_v_2024_godu\n/6767",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 989,
        "Новый id статьи": 6768,
        "Старый url": "https://ecomru.ru/ru/article/vse_chto_nuzhno_znat_o_parsinge_sajtov_v_2024_godu/989",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/vse_chto_nuzhno_znat_o_parsinge_sajtov_v_2024_godu/6768",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 999,
        "Новый id статьи": 6769,
        "Старый url": "https://ecomru.ru/ru/article/kak_prodavat_handmade-tovary_na_marketplejsah/999",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kak_prodavat_handmade-tovary_na_marketplejsah/6769",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1000,
        "Новый id статьи": 6770,
        "Старый url": "https://ecomru.ru/ru/article/fbo_i_fbs_po_kakoj_sheme_luchshe_torgovat_na_marketplejsah\n/1000",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/fbo_i_fbs_po_kakoj_sheme_luchshe_torgovat_na_marketplejsah\n/6770",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1001,
        "Новый id статьи": 6771,
        "Старый url": "https://ecomru.ru/ru/article/top-10_kitajskih_sajtov_na_kotoryh_vy_smozhete_najti_tovary_po_luchshim_tsenam/1001",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/top-10_kitajskih_sajtov_na_kotoryh_vy_smozhete_najti_tovary_po_luchshim_tsenam/6771",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1002,
        "Новый id статьи": 6772,
        "Старый url": "https://ecomru.ru/ru/article/top-5_sovetov_dlja_uluchshenija_vizuala_v_kartochke_tovara_na_marketplejse/1002",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/top-5_sovetov_dlja_uluchshenija_vizuala_v_kartochke_tovara_na_marketplejse/6772",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1003,
        "Новый id статьи": 6773,
        "Старый url": "https://ecomru.ru/ru/article/top-5_mifov_o_torgovle_na_marketplejsah_kakie_zabluzhdenija_meshajut_novichkam_otkryt_biznes/1003",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/top-5_mifov_o_torgovle_na_marketplejsah_kakie_zabluzhdenija_meshajut_novichkam_otkryt_biznes/6773",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1008,
        "Новый id статьи": 6774,
        "Старый url": "https://ecomru.ru/ru/article/osobennosti_parsinga_dannyh_s_megamarket_i_jandeksmarket/1008",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/osobennosti_parsinga_dannyh_s_megamarket_i_jandeksmarket/6774",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1009,
        "Новый id статьи": 6775,
        "Старый url": "https://ecomru.ru/ru/article/chto_takoe_analiz_brenda_na_marketplejsah/1009",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/chto_takoe_analiz_brenda_na_marketplejsah/6775",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1010,
        "Новый id статьи": 6776,
        "Старый url": "https://ecomru.ru/ru/article/top-5_metodov_prodvizhenija_na_marketplejsah_bez_vlozhenij/1010",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/top-5_metodov_prodvizhenija_na_marketplejsah_bez_vlozhenij/6776",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1011,
        "Новый id статьи": 6777,
        "Старый url": "https://ecomru.ru/ru/article/top-4_populjarnyh_oshibki_pri_oformlenii_kartochki_tovara_na_marketplejse/1011",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/top-4_populjarnyh_oshibki_pri_oformlenii_kartochki_tovara_na_marketplejse/6777",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1012,
        "Новый id статьи": 6778,
        "Старый url": "https://ecomru.ru/ru/article/kak_prodavat_tovary_po_nizkim_tsenam_na_marketplejsah_top_luchshih_strategij/1012",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kak_prodavat_tovary_po_nizkim_tsenam_na_marketplejsah_top_luchshih_strategij/6778",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1013,
        "Новый id статьи": 6779,
        "Старый url": "https://ecomru.ru/ru/article/sebestoimost_tovara_na_marketplejse_chto_eto_i_kak_ee_vychislit/1013",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/sebestoimost_tovara_na_marketplejse_chto_eto_i_kak_ee_vychislit/6779",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1015,
        "Новый id статьи": 6780,
        "Старый url": "https://ecomru.ru/ru/article/top-4_samyh_effektivnyh_programmy_dlja_parsinga_dannyh_na_python/1015",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/top-4_samyh_effektivnyh_programmy_dlja_parsinga_dannyh_na_python/6780",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1017,
        "Новый id статьи": 6781,
        "Старый url": "https://ecomru.ru/ru/article/kak_parsing_nedvizhimosti_pomozhet_optimizirovat_vash_biznes/1017",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kak_parsing_nedvizhimosti_pomozhet_optimizirovat_vash_biznes/6781",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1020,
        "Новый id статьи": 6782,
        "Старый url": "https://ecomru.ru/ru/article/kak_startovat_na_marketplejsah_v_2024_godu_5_glavnyh_pravil/1020",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kak_startovat_na_marketplejsah_v_2024_godu_5_glavnyh_pravil/6782",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1032,
        "Новый id статьи": 6783,
        "Старый url": "https://ecomru.ru/ru/article/top-5_rabochih_metodov_dlja_povyshenija_reputatsii_prodavtsa_na_marketplejsah/1032",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/top-5_rabochih_metodov_dlja_povyshenija_reputatsii_prodavtsa_na_marketplejsah/6783",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1033,
        "Новый id статьи": 6784,
        "Старый url": "https://ecomru.ru/ru/article/top-4_oshibki_sellerov_pri_vybore_tovara_dlja_prodazh_na_marketplejsah/1033",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/top-4_oshibki_sellerov_pri_vybore_tovara_dlja_prodazh_na_marketplejsah/6784",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1035,
        "Новый id статьи": 6785,
        "Старый url": "https://ecomru.ru/ru/article/kak_parsing_avtotovarov_pomozhet_optimizirovat_vash_biznes/1035",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kak_parsing_avtotovarov_pomozhet_optimizirovat_vash_biznes/6785",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1054,
        "Новый id статьи": 6786,
        "Старый url": "https://ecomru.ru/ru/article/osobennosti_parsinga_json/1054",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/osobennosti_parsinga_json/6786",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1055,
        "Новый id статьи": 6787,
        "Старый url": "https://ecomru.ru/ru/article/reklamnye_rashody_na_marketplejsah_kak_ih_rasschitat_i_sokratit/1055",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/reklamnye_rashody_na_marketplejsah_kak_ih_rasschitat_i_sokratit/6787",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1056,
        "Новый id статьи": 6788,
        "Старый url": "https://ecomru.ru/ru/article/chto_takoe_protsent_vykupa_na_marketplejsah_pochemu_etot_pokazatel_vazhen_dlja_biznesa/1056",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/chto_takoe_protsent_vykupa_na_marketplejsah_pochemu_etot_pokazatel_vazhen_dlja_biznesa/6788",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1057,
        "Новый id статьи": 6789,
        "Старый url": "https://ecomru.ru/ru/article/poetapnyj_plan_analiza_konkurentov_na_marketplejsah/1057",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/poetapnyj_plan_analiza_konkurentov_na_marketplejsah/6789",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1058,
        "Новый id статьи": 6790,
        "Старый url": "https://ecomru.ru/ru/article/pochemu_demping_eto_ne_luchshee_reshenie_dlja_povyshenija_prodazh_na_marketplejsah/1058",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/pochemu_demping_eto_ne_luchshee_reshenie_dlja_povyshenija_prodazh_na_marketplejsah/6790",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1059,
        "Новый id статьи": 6791,
        "Старый url": "https://ecomru.ru/ru/article/plagiat_na_marketplejsah_chto_budet_za_ispolzovanie_chuzhih_izobrazhenij/1059",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/plagiat_na_marketplejsah_chto_budet_za_ispolzovanie_chuzhih_izobrazhenij/6791",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1061,
        "Новый id статьи": 6792,
        "Старый url": "https://ecomru.ru/ru/article/kak_parsing_kljuchevyh_slov_pomozhet_optimizirovat_vash_biznes/1061",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kak_parsing_kljuchevyh_slov_pomozhet_optimizirovat_vash_biznes/6792",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1069,
        "Новый id статьи": 6793,
        "Старый url": "https://ecomru.ru/ru/article/chem_parsing_avito_polezen_dlja_biznesa/1069",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/chem_parsing_avito_polezen_dlja_biznesa/6793",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1071,
        "Новый id статьи": 6794,
        "Старый url": "https://ecomru.ru/ru/article/chem_parsing_dannyh_polezen_dlja_aptechnogo_biznesa/1071",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/chem_parsing_dannyh_polezen_dlja_aptechnogo_biznesa/6794",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1076,
        "Новый id статьи": 6795,
        "Старый url": "https://ecomru.ru/ru/article/pochemu_parsing_vkontakte_neobhodim_vashemu_biznesu/1076",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/pochemu_parsing_vkontakte_neobhodim_vashemu_biznesu/6795",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1078,
        "Новый id статьи": 6796,
        "Старый url": "https://ecomru.ru/ru/article/chem_parsing_telegram_polezen_dlja_vashego_biznesa/1078",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/chem_parsing_telegram_polezen_dlja_vashego_biznesa/6796",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1105,
        "Новый id статьи": 6797,
        "Старый url": "https://ecomru.ru/ru/article/komanda_ecomru/1105",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/komanda_ecomru/6797",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1107,
        "Новый id статьи": 6798,
        "Старый url": "https://ecomru.ru/ru/article/konkurentnyj_analiz_rynka_kak_najti_svoih_konkurentov_i_kakie_dannye_po_nim_izuchat/1107",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/konkurentnyj_analiz_rynka_kak_najti_svoih_konkurentov_i_kakie_dannye_po_nim_izuchat/6798",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1108,
        "Новый id статьи": 6799,
        "Старый url": "https://ecomru.ru/ru/article/chto_takoe_oborachivaemost_tovara_na_marketplejse_i_zachem_ee_nuzhno_vychisljat/1108",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/chto_takoe_oborachivaemost_tovara_na_marketplejse_i_zachem_ee_nuzhno_vychisljat/6799",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1109,
        "Новый id статьи": 6800,
        "Старый url": "https://ecomru.ru/ru/article/chto_takoe_marzha_i_marzhinalnost_v_chem_otlichija_mezhdu_nimi_i_kak_ih_pravilno_rasschitat/1109",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/chto_takoe_marzha_i_marzhinalnost_v_chem_otlichija_mezhdu_nimi_i_kak_ih_pravilno_rasschitat/6800",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1110,
        "Новый id статьи": 6801,
        "Старый url": "https://ecomru.ru/ru/article/5_kljuchevyh_pokazatelej_na_kotorye_nuzhno_smotret_pri_analize_marketplejsov/1110",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/5_kljuchevyh_pokazatelej_na_kotorye_nuzhno_smotret_pri_analize_marketplejsov/6801",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1111,
        "Новый id статьи": 6802,
        "Старый url": "https://ecomru.ru/ru/article/kto_takoj_menedzher_marketplejsov_i_chem_on_zanimaetsja/1111",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kto_takoj_menedzher_marketplejsov_i_chem_on_zanimaetsja/6802",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1112,
        "Новый id статьи": 6803,
        "Старый url": "https://ecomru.ru/ru/article/top_10_sposobov_uvelichit_prodazhi_na_marketplejsah_i_podnjat_effektivnost_svoego_biznesa/1112",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/top_10_sposobov_uvelichit_prodazhi_na_marketplejsah_i_podnjat_effektivnost_svoego_biznesa/6803",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1123,
        "Новый id статьи": 6804,
        "Старый url": "https://ecomru.ru/ru/article/osnovnye_razlichija_mezhdu_parsingom_dannyh_i_veb-skrapingom/1123",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/osnovnye_razlichija_mezhdu_parsingom_dannyh_i_veb-skrapingom/6804",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1125,
        "Новый id статьи": 6805,
        "Старый url": "https://ecomru.ru/ru/article/osobennosti_parsinga_dannyh_s_wildberries_i_ozon/1125",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/osobennosti_parsinga_dannyh_s_wildberries_i_ozon/6805",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1133,
        "Новый id статьи": 6806,
        "Старый url": "https://ecomru.ru/ru/article/kak_prodavat_premium-tovary_na_marketplejsah/1133",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kak_prodavat_premium-tovary_na_marketplejsah/6806",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1134,
        "Новый id статьи": 6807,
        "Старый url": "https://ecomru.ru/ru/article/kak_prodavat_detskie_igrushki_na_marketplejsah/1134",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kak_prodavat_detskie_igrushki_na_marketplejsah/6807",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1135,
        "Новый id статьи": 6808,
        "Старый url": "https://ecomru.ru/ru/article/kak_pravilno_upakovat_tovar_dlja_torgovli_na_marketplejsah/1135",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kak_pravilno_upakovat_tovar_dlja_torgovli_na_marketplejsah/6808",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1136,
        "Новый id статьи": 6809,
        "Старый url": "https://ecomru.ru/ru/article/chto_takoe_analiz_sku_na_marketplejsah/1136",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/chto_takoe_analiz_sku_na_marketplejsah/6809",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1137,
        "Новый id статьи": 6810,
        "Старый url": "https://ecomru.ru/ru/article/top-5_vostrebovannyh_tovarov_s_kotorymi_prjamo_sejchas_mozhno_vyhodit_na_wildberries/1137",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/top-5_vostrebovannyh_tovarov_s_kotorymi_prjamo_sejchas_mozhno_vyhodit_na_wildberries/6810",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1151,
        "Новый id статьи": 6811,
        "Старый url": "https://ecomru.ru/ru/article/osobennosti_parsinga_fajlov/1151",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/osobennosti_parsinga_fajlov/6811",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1153,
        "Новый id статьи": 6812,
        "Старый url": "https://ecomru.ru/ru/article/zachem_nuzhno_parsit_otzyvy_na_sajtah_konkurentov/1153",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/zachem_nuzhno_parsit_otzyvy_na_sajtah_konkurentov/6812",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1154,
        "Новый id статьи": 6813,
        "Старый url": "https://ecomru.ru/ru/article/kak_pravilno_rabotat_s_reklamoj_na_marketplejsah/1154",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kak_pravilno_rabotat_s_reklamoj_na_marketplejsah/6813",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1155,
        "Новый id статьи": 6814,
        "Старый url": "https://ecomru.ru/ru/article/kak_pravilno_oformit_kartochku_tovara_na_marketplejse/1155",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kak_pravilno_oformit_kartochku_tovara_na_marketplejse/6814",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1156,
        "Новый id статьи": 6815,
        "Старый url": "https://ecomru.ru/ru/article/missija_kompanii_ecomseller/1156",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/missija_kompanii_ecomseller/6815",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1158,
        "Новый id статьи": 6816,
        "Старый url": "https://ecomru.ru/ru/article/top-5_idej_dlja_ispolzovanija_parsinga_dannyh_v_biznese/1158",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/top-5_idej_dlja_ispolzovanija_parsinga_dannyh_v_biznese/6816",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1163,
        "Новый id статьи": 6817,
        "Старый url": "https://ecomru.ru/ru/article/poshagovyj_plan_veb-skrapinga_sajtov/1163",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/poshagovyj_plan_veb-skrapinga_sajtov/6817",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1174,
        "Новый id статьи": 6818,
        "Старый url": "https://ecomru.ru/ru/article/chem_polezen_parsing_sajtov_bankovskih_sistem/1174",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/chem_polezen_parsing_sajtov_bankovskih_sistem/6818",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1176,
        "Новый id статьи": 6819,
        "Старый url": "https://ecomru.ru/ru/article/chem_polezen_parsing_sajtov_po_poisku_raboty/1176",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/chem_polezen_parsing_sajtov_po_poisku_raboty/6819",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1177,
        "Новый id статьи": 6820,
        "Старый url": "https://ecomru.ru/ru/article/kak_pravilno_analizirovat_ploschadku_marketplejsa/1177",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kak_pravilno_analizirovat_ploschadku_marketplejsa/6820",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1178,
        "Новый id статьи": 6821,
        "Старый url": "https://ecomru.ru/ru/article/iz_chego_skladyvaetsja_seo-optimizatsija_na_marketplejsah/1178",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/iz_chego_skladyvaetsja_seo-optimizatsija_na_marketplejsah/6821",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1179,
        "Новый id статьи": 6822,
        "Старый url": "https://ecomru.ru/ru/article/dropshipping_vsë_chto_nuzhno_znat_ob_etom_vide_torgovli/1179",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/dropshipping_vsë_chto_nuzhno_znat_ob_etom_vide_torgovli/6822",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1180,
        "Новый id статьи": 6823,
        "Старый url": "https://ecomru.ru/ru/article/kak_pravilno_vybrat_nishu_dlja_torgovli_na_marketplejsah/1180",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kak_pravilno_vybrat_nishu_dlja_torgovli_na_marketplejsah/6823",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1181,
        "Новый id статьи": 6824,
        "Старый url": "https://ecomru.ru/ru/article/vse_chto_nuzhno_znat_o_vneshnej_reklame_na_marketplejsah/1181",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/vse_chto_nuzhno_znat_o_vneshnej_reklame_na_marketplejsah/6824",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1189,
        "Новый id статьи": 6825,
        "Старый url": "https://ecomru.ru/ru/article/kakie_kakie_instrumenty_chasche_vsego_ispolzujutsja_dlja_parsinga_sajtov/1189",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kakie_kakie_instrumenty_chasche_vsego_ispolzujutsja_dlja_parsinga_sajtov/6825",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1191,
        "Новый id статьи": 6826,
        "Старый url": "https://ecomru.ru/ru/article/chem_parsing_avtomobilnyh_sajtov_polezen_dlja_biznesa/1191",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/chem_parsing_avtomobilnyh_sajtov_polezen_dlja_biznesa/6826",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1193,
        "Новый id статьи": 6827,
        "Старый url": "https://ecomru.ru/ru/article/chem_polezen_parsing_internet-magazinov_detskih_tovarov/1193",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/chem_polezen_parsing_internet-magazinov_detskih_tovarov/6827",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1195,
        "Новый id статьи": 6828,
        "Старый url": "https://ecomru.ru/ru/article/osobennosti_parsinga_html/1195",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/osobennosti_parsinga_html/6828",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1234,
        "Новый id статьи": 6698,
        "Старый url": "https://ecomru.ru/ru/article/kejs_po_perenosu_5000_sku_odezhdy_s_ozon_na_jandeksmarket/1234",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kejs_po_perenosu_5000_sku_odezhdy_s_ozon_na_jandeksmarket/6698",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1242,
        "Новый id статьи": 6830,
        "Старый url": "https://ecomru.ru/ru/article/kejs:_podkljuchenie_seti_oflajn-magazinov_na_ozon_po_express_dostavke_naprjamuju_iz_magazina/1242",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kejs:_podkljuchenie_seti_oflajn-magazinov_na_ozon_po_express_dostavke_naprjamuju_iz_magazina/6830",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1250,
        "Новый id статьи": 6831,
        "Старый url": "https://ecomru.ru/ru/article/proksi_dlja_parsinga_sajtov_kak_eto_rabotaet_i_chem_polezno/1250",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/proksi_dlja_parsinga_sajtov_kak_eto_rabotaet_i_chem_polezno/6831",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1253,
        "Новый id статьи": 6832,
        "Старый url": "https://ecomru.ru/ru/article/dlja_chego_nuzhna_analitika_na_marketplejsah/1253",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/dlja_chego_nuzhna_analitika_na_marketplejsah/6832",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1261,
        "Новый id статьи": 6833,
        "Старый url": "https://ecomru.ru/ru/article/v_chem_raznitsa_mezhdu_alibaba_i_aliexpress_gde_luchshe_iskat_postavschikov/1261",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/v_chem_raznitsa_mezhdu_alibaba_i_aliexpress_gde_luchshe_iskat_postavschikov/6833",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1262,
        "Новый id статьи": 6834,
        "Старый url": "https://ecomru.ru/ru/article/brakovannye_tovary_chto_delat_chtoby_svesti_ubytki_k_minimumu/1262",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/brakovannye_tovary_chto_delat_chtoby_svesti_ubytki_k_minimumu/6834",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1268,
        "Новый id статьи": 6835,
        "Старый url": "https://ecomru.ru/ru/article/assortimentnaja_matritsa_na_marketplejsah_chto_eto_takoe_i_kak_ee_pravilno_sformirovat/1268",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/assortimentnaja_matritsa_na_marketplejsah_chto_eto_takoe_i_kak_ee_pravilno_sformirovat/6835",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1269,
        "Новый id статьи": 6836,
        "Старый url": "https://ecomru.ru/ru/article/top-5_povodov_obnovit_kartochku_tovara_na_marketplejse/1269",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/top-5_povodov_obnovit_kartochku_tovara_na_marketplejse/6836",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1270,
        "Новый id статьи": 6837,
        "Старый url": "https://ecomru.ru/ru/article/5_osnovnyh_oshibok_sellerov-novichkov_pri_podbore_kljuchevyh_slov_na_marketplejsah/1270",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/5_osnovnyh_oshibok_sellerov-novichkov_pri_podbore_kljuchevyh_slov_na_marketplejsah/6837",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1302,
        "Новый id статьи": 6838,
        "Старый url": "https://ecomru.ru/ru/article/top-5_luchshih_zarubezhnyh_knig_posvjaschennyh_elektronnoj_torgovle/1302",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/top-5_luchshih_zarubezhnyh_knig_posvjaschennyh_elektronnoj_torgovle/6838",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1313,
        "Новый id статьи": 6839,
        "Старый url": "https://ecomru.ru/ru/article/4_osnovnye_oshibki_sellerov_pri_rabote_s_kitajskim_rynkom/1313",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/4_osnovnye_oshibki_sellerov_pri_rabote_s_kitajskim_rynkom/6839",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1317,
        "Новый id статьи": 6840,
        "Старый url": "https://ecomru.ru/ru/article/kak_otzyvy_vlijajut_na_chislo_prodazh_na_marketplejsah/1317",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kak_otzyvy_vlijajut_na_chislo_prodazh_na_marketplejsah/6840",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1327,
        "Новый id статьи": 6841,
        "Старый url": "https://ecomru.ru/ru/article/top-5_sposobov_obojti_konkurentov_na_marketplejsah/1327",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/top-5_sposobov_obojti_konkurentov_na_marketplejsah/6841",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1330,
        "Новый id статьи": 6842,
        "Старый url": "https://ecomru.ru/ru/article/chek-list_po_sozdaniju_klientoorientirovannoj_strategii_marketinga/1330",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/chek-list_po_sozdaniju_klientoorientirovannoj_strategii_marketinga/6842",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1337,
        "Новый id статьи": 6843,
        "Старый url": "https://ecomru.ru/ru/article/7_osnovnyh_printsipov_prodajuschego_opisanija_tovara_na_marketplejsah/1337",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/7_osnovnyh_printsipov_prodajuschego_opisanija_tovara_na_marketplejsah/6843",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1338,
        "Новый id статьи": 6844,
        "Старый url": "https://ecomru.ru/ru/article/10_samyh_populjarnyh_tovarov_dlja_kuhni_na_marketplejsah_v_2024_godu/1338",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/10_samyh_populjarnyh_tovarov_dlja_kuhni_na_marketplejsah_v_2024_godu/6844",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1346,
        "Новый id статьи": 6845,
        "Старый url": "https://ecomru.ru/ru/article/kejs_parsing_dannyh_dlja_krupnogo_mezhdunarodnogo_brenda_tovarov_fmcg/1346",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kejs_parsing_dannyh_dlja_krupnogo_mezhdunarodnogo_brenda_tovarov_fmcg/6845",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1351,
        "Новый id статьи": 6846,
        "Старый url": "https://ecomru.ru/ru/article/kak_sdelat_privlekatelnye_izobrazhenija_tovara_dlja_marketplejsov_v_domashnih_uslovijah/1351",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kak_sdelat_privlekatelnye_izobrazhenija_tovara_dlja_marketplejsov_v_domashnih_uslovijah/6846",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1366,
        "Новый id статьи": 6847,
        "Старый url": "https://ecomru.ru/ru/article/vse_chto_nuzhno_znat_o_zakupke_tovarov_na_alibaba/1366",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/vse_chto_nuzhno_znat_o_zakupke_tovarov_na_alibaba/6847",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1370,
        "Новый id статьи": 6848,
        "Старый url": "https://ecomru.ru/ru/article/pochemu_torgovlja_na_marketplejsah_eto_luchshee_napravlenie_dlja_biznesa_v_2024_godu/1370",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/pochemu_torgovlja_na_marketplejsah_eto_luchshee_napravlenie_dlja_biznesa_v_2024_godu/6848",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1378,
        "Новый id статьи": 6849,
        "Старый url": "https://ecomru.ru/ru/article/kak_pravilno_vybrat_vtoroj_marketplejs_dlja_rasshirenija_biznesa/1378",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kak_pravilno_vybrat_vtoroj_marketplejs_dlja_rasshirenija_biznesa/6849",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1379,
        "Новый id статьи": 6850,
        "Старый url": "https://ecomru.ru/ru/article/kak_analitika_marketplejsov_vlijaet_na_prodazhi_i_vyruchku_sellerov/1379",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kak_analitika_marketplejsov_vlijaet_na_prodazhi_i_vyruchku_sellerov/6850",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1400,
        "Новый id статьи": 6851,
        "Старый url": "https://ecomru.ru/ru/article/poshagovyj_plan_dlja_effektivnoj_podgotovki_kartochki_tovara_k_reklamnym_kampanijam/1400",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/poshagovyj_plan_dlja_effektivnoj_podgotovki_kartochki_tovara_k_reklamnym_kampanijam/6851",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1423,
        "Новый id статьи": 6852,
        "Старый url": "https://ecomru.ru/ru/article/v_chem_zakljuchaetsja_vzaimosvjaz_mezhdu_organicheskim_poiskom_i_reklamnymi_kompanijami_na_marketplejsah/1423",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/v_chem_zakljuchaetsja_vzaimosvjaz_mezhdu_organicheskim_poiskom_i_reklamnymi_kompanijami_na_marketplejsah/6852",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1424,
        "Новый id статьи": 6853,
        "Старый url": "https://ecomru.ru/ru/article/pochemu_vazhno_prodvigat_svoj_brend_na_marketplejsah/1424",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/pochemu_vazhno_prodvigat_svoj_brend_na_marketplejsah/6853",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1434,
        "Новый id статьи": 6854,
        "Старый url": "https://ecomru.ru/ru/article/kejs_sozdanie_analiticheskogo_dashborda_dlja_krupnogo_brenda_odezhdy/1434",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kejs_sozdanie_analiticheskogo_dashborda_dlja_krupnogo_brenda_odezhdy/6854",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1435,
        "Новый id статьи": 6855,
        "Старый url": "https://ecomru.ru/ru/article/ecomseller_voshel_v_top-10_krupnejshih_tehnologicheskih_partnerov_jandeks_market/1435",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/ecomseller_voshel_v_top-10_krupnejshih_tehnologicheskih_partnerov_jandeks_market/6855",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1482,
        "Новый id статьи": 6856,
        "Старый url": "https://ecomru.ru/ru/article/kak_prodavat_tovary_v_kategorii_elektronika_na_marketplejsah/1482",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kak_prodavat_tovary_v_kategorii_elektronika_na_marketplejsah/6856",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1684,
        "Новый id статьи": 6857,
        "Старый url": "https://ecomru.ru/ru/article/kejs_integratsija_s_marketplejsami_dlja_futbolnogo_kluba_dinamo_moskva/1684",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kejs_integratsija_s_marketplejsami_dlja_futbolnogo_kluba_dinamo_moskva/6857",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1696,
        "Новый id статьи": 6858,
        "Старый url": "https://ecomru.ru/ru/article/zachem_nuzhna_analitika_marketplejsov_i_kak_ona_pomogaet_optimizirovat_biznes/1696",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/zachem_nuzhna_analitika_marketplejsov_i_kak_ona_pomogaet_optimizirovat_biznes/6858",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1700,
        "Новый id статьи": 6859,
        "Старый url": "https://ecomru.ru/ru/article/marketplejsy_vs_internet-magaziny_stoit_li_sozdavat_svoj_sajt_dlja_e-com_biznesa/1700",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/marketplejsy_vs_internet-magaziny_stoit_li_sozdavat_svoj_sajt_dlja_e-com_biznesa/6859",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1768,
        "Новый id статьи": 6860,
        "Старый url": "https://ecomru.ru/ru/article/kak_uvelichit_pribyl_svoego_internet-magazina_v_2024_godu_top_7_samyh_effektivnyh_sposobov_privlechenija_trafika/1768",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kak_uvelichit_pribyl_svoego_internet-magazina_v_2024_godu_top_7_samyh_effektivnyh_sposobov_privlechenija_trafika/6860",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1774,
        "Новый id статьи": 6861,
        "Старый url": "https://ecomru.ru/ru/article/poshagovyj_plan_kak_nachat_e-commerce_biznes_v_2024_godu/1774",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/poshagovyj_plan_kak_nachat_e-commerce_biznes_v_2024_godu/6861",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1799,
        "Новый id статьи": 6862,
        "Старый url": "https://ecomru.ru/ru/article/pochemu_avtomatizatsija_biznesa_neobhodima_dlja_dostizhenija_vysokih_rezultatov_v_e-commerce/1799",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/pochemu_avtomatizatsija_biznesa_neobhodima_dlja_dostizhenija_vysokih_rezultatov_v_e-commerce/6862",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 1846,
        "Новый id статьи": 6863,
        "Старый url": "https://ecomru.ru/ru/article/publichnaja_oferta_predlozhenie_o_zakljuchenii_dogovora_okazanija_uslug_distantsionnym_sposobom/1846",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/publichnaja_oferta_predlozhenie_o_zakljuchenii_dogovora_okazanija_uslug_distantsionnym_sposobom/6863",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 3149,
        "Новый id статьи": 6864,
        "Старый url": "https://ecomru.ru/ru/article/chto_takoe_pim_sistema_kakie_biznes-zadachi_ona_reshaet_i_kak_ee_pravilno_vnedrit/3149",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/chto_takoe_pim_sistema_kakie_biznes-zadachi_ona_reshaet_i_kak_ee_pravilno_vnedrit/6864",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 3218,
        "Новый id статьи": 6865,
        "Старый url": "https://ecomru.ru/ru/article/chto_takoe_chat-bot_i_pochemu_on_neobhodim_vashemu_biznesu/3218",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/chto_takoe_chat-bot_i_pochemu_on_neobhodim_vashemu_biznesu/6865",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 3244,
        "Новый id статьи": 6866,
        "Старый url": "https://ecomru.ru/ru/article/crm_sistema_-_chto_eto_takoe_kak_ona_rabotaet_i_kak_ee_pravilno_vnedrit_v_biznes/3244",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/crm_sistema_-_chto_eto_takoe_kak_ona_rabotaet_i_kak_ee_pravilno_vnedrit_v_biznes/6866",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 3665,
        "Новый id статьи": 6867,
        "Старый url": "https://ecomru.ru/ru/article/chto_takoe_baza_znanij_wiki_i_dlja_kakih_tselej_ona_nuzhna/3665",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/chto_takoe_baza_znanij_wiki_i_dlja_kakih_tselej_ona_nuzhna/6867",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 3839,
        "Новый id статьи": 6868,
        "Старый url": "https://ecomru.ru/ru/article/kejs_parsinga_i_monitoringa_tsen_dlja_krupnogo_brenda_bytovoj_tehniki/3839",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kejs_parsinga_i_monitoringa_tsen_dlja_krupnogo_brenda_bytovoj_tehniki/6868",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 3905,
        "Новый id статьи": 6869,
        "Старый url": "https://ecomru.ru/ru/article/kak_vnedrit_rag_sistemu_chtoby_sluzhba_podderzhki_stala_po_nastojaschemu_effektivnoj/3905",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kak_vnedrit_rag_sistemu_chtoby_sluzhba_podderzhki_stala_po_nastojaschemu_effektivnoj/6869",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 3927,
        "Новый id статьи": 6870,
        "Старый url": "https://ecomru.ru/ru/article/v_chem_osnovnaja_raznitsa_mezhdu_pim_i_plm_sistemami/3927",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/v_chem_osnovnaja_raznitsa_mezhdu_pim_i_plm_sistemami/6870",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 3964,
        "Новый id статьи": 6871,
        "Старый url": "https://ecomru.ru/ru/article/bez_lishnih_usilij:_5_proverennyh_sposobov_avtomatizirovat_biznes_na_marketplejsah/3964",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/bez_lishnih_usilij:_5_proverennyh_sposobov_avtomatizirovat_biznes_na_marketplejsah/6871",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 3975,
        "Новый id статьи": 6872,
        "Старый url": "https://ecomru.ru/ru/article/chto_takoe_servis_avtopostinga_dlja_sotsialnyh_setej_i_zachem_on_nuzhen_biznesu/3975",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/chto_takoe_servis_avtopostinga_dlja_sotsialnyh_setej_i_zachem_on_nuzhen_biznesu/6872",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 3993,
        "Новый id статьи": 6873,
        "Старый url": "https://ecomru.ru/ru/article/kak_analizirovat_marketingovye_strategii_konkurentov/3993",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kak_analizirovat_marketingovye_strategii_konkurentov/6873",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 4015,
        "Новый id статьи": 6874,
        "Старый url": "https://ecomru.ru/ru/article/chto_takoe_task-menedzher_i_zachem_on_nuzhen_biznesu/4015",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/chto_takoe_task-menedzher_i_zachem_on_nuzhen_biznesu/6874",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 4845,
        "Новый id статьи": 6875,
        "Старый url": "https://ecomru.ru/ru/article/chto_takoe_izderzhki_biznesa_i_kak_ih_mozhno_snizit/4845",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/chto_takoe_izderzhki_biznesa_i_kak_ih_mozhno_snizit/6875",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 5079,
        "Новый id статьи": 6876,
        "Старый url": "https://ecomru.ru/ru/article/v_chem_razlichija_mezhdu_brendom_tovarnym_znakom_i_torgovoj_markoj/5079",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/v_chem_razlichija_mezhdu_brendom_tovarnym_znakom_i_torgovoj_markoj/6876",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 5427,
        "Новый id статьи": 6877,
        "Старый url": "https://ecomru.ru/ru/article/top_5_sposobov_kak_chatgpt_pomogaet_optimizirovat_biznes_v_ecommerce/5427",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/top_5_sposobov_kak_chatgpt_pomogaet_optimizirovat_biznes_v_ecommerce/6877",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 6087,
        "Новый id статьи": 6878,
        "Старый url": "https://ecomru.ru/ru/article/kejs_monitoringa_share_of_spend_dlja_krupnogo_mezhdunarodnogo_brenda/6087",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kejs_monitoringa_share_of_spend_dlja_krupnogo_mezhdunarodnogo_brenda/6878",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 6093,
        "Новый id статьи": 6879,
        "Старый url": "https://ecomru.ru/ru/article/kejs_parsinga_i_monitoringa_share_in_search_dlja_mezhdunarodnogo_brenda/6093",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kejs_parsinga_i_monitoringa_share_in_search_dlja_mezhdunarodnogo_brenda/6879",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 6095,
        "Новый id статьи": 6880,
        "Старый url": "https://ecomru.ru/ru/article/kejs_monitoringa_kachestva_prisutstvija_v_onlajn_dlja_krupnogo_brenda/6095",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kejs_monitoringa_kachestva_prisutstvija_v_onlajn_dlja_krupnogo_brenda/6880",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 6280,
        "Новый id статьи": 9051,
        "Старый url": "https://ecomru.ru/ru/article/pochemu_strategicheski_vazhno_torgovat_na_neskolkih_marketplejsah/6280",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/pochemu_strategicheski_vazhno_torgovat_na_neskolkih_marketplejsah/9051",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 6439,
        "Новый id статьи": 9052,
        "Старый url": "https://ecomru.ru/ru/article/ecomseller_podnjalsja_v_top-5_krupnejshih_tehnologicheskih_partnerov_jandeks_market/6439",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/ecomseller_podnjalsja_v_top-5_krupnejshih_tehnologicheskih_partnerov_jandeks_market/9052",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 6633,
        "Новый id статьи": 6653,
        "Старый url": "https://ecomru.ru/ru/article/chto_nuzhno_chtoby_horosho_prodavat_na_marketplejsah/6633",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/chto_nuzhno_chtoby_horosho_prodavat_na_marketplejsah/6653",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 6634,
        "Новый id статьи": 6654,
        "Старый url": "https://ecomru.ru/ru/article/vygodno_li_torgovat_na_marketplejsah/6634",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/vygodno_li_torgovat_na_marketplejsah/6654",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 6635,
        "Новый id статьи": 6654,
        "Старый url": "https://ecomru.ru/ru/article/vygodno_li_torgovat_na_marketplejsah/6635",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/vygodno_li_torgovat_na_marketplejsah/6654",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 6651,
        "Новый id статьи": 6627,
        "Старый url": "https://ecomru.ru/ru/article/kak_nachat_prodavat_na_jandeksmarket/6651",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kak_nachat_prodavat_na_jandeksmarket/6627",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 6655,
        "Новый id статьи": 6656,
        "Старый url": "https://ecomru.ru/ru/article/kak_monitorjat_tseny_markeplejsy/6655",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kak_monitorjat_tseny_markeplejsy/6656",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 6700,
        "Новый id статьи": 6711,
        "Старый url": "https://ecomru.ru/ru/article/kak_prodavat_na_wildberries_samozanjatym/6700",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kak_prodavat_na_wildberries_samozanjatym/6711",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 6709,
        "Новый id статьи": 6711,
        "Старый url": "https://ecomru.ru/ru/article/kak_prodavat_na_wildberries_samozanjatym/6709",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kak_prodavat_na_wildberries_samozanjatym/6711",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 6710,
        "Новый id статьи": 6648,
        "Старый url": "https://ecomru.ru/ru/article/kak_prodavat_bady_na_marketplejsah/6710",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kak_prodavat_bady_na_marketplejsah/6648",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 6719,
        "Новый id статьи": 6830,
        "Старый url": "https://ecomru.ru/ru/article/kejs:_podkljuchenie_seti_oflajn-magazinov_na_ozon_po_express_dostavke_naprjamuju_iz_magazina/6719",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kejs:_podkljuchenie_seti_oflajn-magazinov_na_ozon_po_express_dostavke_naprjamuju_iz_magazina/6830",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 6829,
        "Новый id статьи": 6698,
        "Старый url": "https://ecomru.ru/ru/article/kejs_po_perenosu_5000_sku_odezhdy_s_ozon_na_jandeksmarket/6829",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kejs_po_perenosu_5000_sku_odezhdy_s_ozon_na_jandeksmarket/6698",
        "Название портала": "ecomru.ru"
    },
    {
        "Старый id статьи": 6830,
        "Новый id статьи": 6719,
        "Старый url": "https://ecomru.ru/ru/article/kejs:_podkljuchenie_seti_oflajn-magazinov_na_ozon_po_express_dostavke_naprjamuju_iz_magazina/6830",
        "Новый url": "https://lk.ecomru.ru/wiki/ru/article/kejs:_podkljuchenie_seti_oflajn-magazinov_na_ozon_po_express_dostavke_naprjamuju_iz_magazina/6719",
        "Название портала": "ecomru.ru"
    }
]



const Test = () => {

    const [productTemporary, setProductTemporary] = useState(initialAttributes)
    const result = articles.map((el) => {
        console.log(el["Старый url"])?.split('https://ecomru.ru')
        return {
            "source": el["Старый url"]?.split('https://ecomru.ru')[1],
            "destination": el["Новый url"]?.split('https://lk.ecomru.ru/wiki')[1],
            "permanent": true
        }
    })
    console.log(result)

    return (
        <div className="test">
            <SimpleFlowEditor />
        </div>
    );
};

export { Test }